(function () {
  'use strict';

  var CARD_SELECTOR = [
    '.products-list .box.product',
    '.products .box.product',
    '.search-results .box.product',
    '.collection .box.product',
    '.product-card',
    '.product-item',
    '[data-product-handle]',
    '[data-product-id]'
  ].join(', ');

  var TITLE_SELECTOR = 'a.product-title, .product-title, h1 a[href*="/products/"], h2 a[href*="/products/"], h3 a[href*="/products/"]';
  var CACHE_PREFIX = 'bioss:conj-options:v62-cy55-handles:';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var startedAt = Date.now();
  var scanTimer = null;
  var pending = {};

  var GROUPS = [
    { key: 'unconjugated', title: 'Unconjugated' },
    { key: 'abby', title: 'AbBy Fluor®' },
    { key: 'standard', title: 'Standard Colors' },
    { key: 'other', title: 'Other Tags' }
  ];

  var LABELS = [
    'PerCP-Cy5.5', 'APC-Cy5.5', 'APC-Cy7', 'PE-Cy5.5', 'PE-Cy7', 'PE-Cy5',
    'BF350', 'BF405', 'BF488', 'BF555', 'BF594', 'BF647', 'BF680', 'BF750',
    'Biotin', 'FITC', 'TRITC', 'RBITC', 'PerCP', 'HRP', 'APC', 'Cy5.5', 'Cy3', 'Cy5', 'Cy7', 'PE', 'AP'
  ];

  function normalize(text) {
    return String(text || '').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
  }

  function normalizeSku(text) {
    return normalize(text).replace(/[^A-Za-z0-9.-]/g, '').toLowerCase();
  }

  function normalizeProductHandle(handle) {
    return String(handle || '').replace(/((?:^|-)(?:(?:percp|apc|pe)-)?cy5)\.5$/i, '$1-5');
  }

  function normalizeUrl(url) {
    if (!url) return '';
    var str = String(url).replace(/\\\//g, '/').replace(/^https?:\/\/[^/]+/i, '').split('#')[0].trim();
    var match = str.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? '/products/' + normalizeProductHandle(match[1]) : '';
  }

  function handleFromUrl(url) {
    var match = String(url || '').replace(/\\\//g, '/').match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? normalizeProductHandle(match[1]) : '';
  }

  function productUrlFromCard(card) {
    if (!card) return '';

    // Prefer the visible product-title link. On SearchSpring pages, this is the most stable
    // source and avoids the first card being read before injected image metadata finishes.
    var titleLink = card.querySelector(TITLE_SELECTOR);
    if (titleLink) {
      var titleHref = titleLink.getAttribute('href') || '';
      if (titleHref.indexOf('/products/') !== -1) return normalizeUrl(titleHref);
    }

    var direct = card.getAttribute('data-product-url') || card.getAttribute('data-url');
    if (direct && direct.indexOf('/products/') !== -1) return normalizeUrl(direct);

    var handle = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    if (handle) return '/products/' + String(handle).replace(/^\/products\//, '').replace(/^\//, '').split(/[?#]/)[0];

    var imageSlot = card.querySelector('[data-bioss-product-card-image], .bioss-card-image-loader, .bioss-card-image-injected');
    if (imageSlot) {
      var slotUrl = imageSlot.getAttribute('data-product-url');
      if (slotUrl && slotUrl.indexOf('/products/') !== -1) return normalizeUrl(slotUrl);

      var endpoint = imageSlot.getAttribute('data-images-endpoint') || '';
      if (endpoint && endpoint.indexOf('/products/') !== -1) return normalizeUrl(endpoint);
    }

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    var href = link.getAttribute('href') || '';
    return href.indexOf('/products/') !== -1 ? normalizeUrl(href) : '';
  }

  function endpointFromProductUrl(productUrl) {
    var handle = handleFromUrl(productUrl);
    return handle ? '/products/' + handle + '?view=conjugation-options&bioss_conj_options_v=62_cy55_handles' : '';
  }

  function readCache(key) {
    if (!key || !window.sessionStorage) return null;
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (!cached || !cached.time || !cached.data) return null;
      if (Date.now() - cached.time > CACHE_TTL_MS) return null;
      return cached.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, data) {
    if (!key || !window.sessionStorage || !data) return;
    try {
      window.sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), data: data }));
    } catch (e) {}
  }

  function fetchPayload(endpoint) {
    if (!endpoint) return Promise.resolve(null);

    var key = CACHE_PREFIX + endpoint;
    var cached = readCache(key);
    if (cached) return Promise.resolve(cached);

    if (pending[endpoint]) return pending[endpoint];

    pending[endpoint] = fetch(endpoint, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('conjugation endpoint failed');
      return response.json();
    }).then(function (payload) {
      writeCache(key, payload);
      delete pending[endpoint];
      return payload;
    }).catch(function () {
      delete pending[endpoint];
      return null;
    });

    return pending[endpoint];
  }

  function stripKnownSuffix(value) {
    var text = normalizeSku(value);
    for (var i = 0; i < LABELS.length; i += 1) {
      var suffix = '-' + LABELS[i].toLowerCase();
      if (text.slice(-suffix.length) === suffix) return text.slice(0, -suffix.length);
    }
    return text;
  }

  function canonicalLabel(label) {
    var upper = normalize(label).replace(/_/g, '-').replace(/\s+/g, '-').toUpperCase();
    var map = {
      'UNCONJUGATED': 'Unconjugated',
      'NONE': 'Unconjugated',
      'NO-CONJUGATION': 'Unconjugated',
      'BF350': 'BF350',
      'BF405': 'BF405',
      'BF488': 'BF488',
      'BF555': 'BF555',
      'BF594': 'BF594',
      'BF647': 'BF647',
      'BF680': 'BF680',
      'BF750': 'BF750',
      'FITC': 'FITC',
      'PE': 'PE',
      'APC': 'APC',
      'CY3': 'Cy3',
      'CY5': 'Cy5',
      'CY5.5': 'Cy5.5',
      'CY5-5': 'Cy5.5',
      'CY7': 'Cy7',
      'PE-CY5': 'PE-Cy5',
      'PE-CY5.5': 'PE-Cy5.5',
      'PE-CY5-5': 'PE-Cy5.5',
      'PE-CY7': 'PE-Cy7',
      'APC-CY5.5': 'APC-Cy5.5',
      'APC-CY5-5': 'APC-Cy5.5',
      'APC-CY7': 'APC-Cy7',
      'PERCP': 'PerCP',
      'PERCP-CY5.5': 'PerCP-Cy5.5',
      'PERCP-CY5-5': 'PerCP-Cy5.5',
      'BIOTIN': 'Biotin',
      'HRP': 'HRP',
      'AP': 'AP',
      'TRITC': 'TRITC',
      'RBITC': 'RBITC'
    };
    return map[upper] || '';
  }

  function labelFromText(text, baseSku) {
    var combined = normalize(text);
    var upper = combined.replace(/_/g, '-').replace(/\s+/g, '-').toUpperCase();
    upper = upper.replace(/((?:^|-)(?:(?:PERCP|APC|PE)-)?CY5)-5(?=$|[-_/])/g, '$1.5');

    if (baseSku && normalizeSku(combined) === normalizeSku(baseSku)) return 'Unconjugated';
    if (/\b(unconjugated|no conjugation|none)\b/i.test(combined)) return 'Unconjugated';

    for (var i = 0; i < LABELS.length; i += 1) {
      var label = LABELS[i];
      var escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var pattern = new RegExp('(^|[-_\\s/])' + escaped.replace(/\\\./g, '[.]') + '($|[-_\\s/])', 'i');
      if (pattern.test(upper)) return canonicalLabel(label);
    }
    return '';
  }

  function groupForLabel(label) {
    if (label === 'Unconjugated') return 'unconjugated';
    if (/^BF/i.test(label)) return 'abby';
    if (/^(FITC|PE|APC|Cy3|Cy5|Cy5\.5|Cy7|PE-Cy5|PE-Cy5\.5|PE-Cy7|APC-Cy5\.5|APC-Cy7|PerCP|PerCP-Cy5\.5)$/i.test(label)) return 'standard';
    return 'other';
  }

  function swatchClass(label, group) {
    if (group === 'unconjugated') return 'conj-unconjugated';
    return 'conj-' + String(label || '')
      .toLowerCase()
      .replace(/\./g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function addEntry(entries, entry) {
    if (!entry) return;
    var url = normalizeUrl(entry.url || entry.href || entry.product_url || entry.productUrl || entry.link || '');
    var handle = normalize(entry.handle || '');
    if (!url && handle) url = '/products/' + handle;
    if (!url) return;

    entries.push({
      title: normalize(entry.title || entry.name || entry.label || ''),
      url: url,
      handle: handleFromUrl(url) || handle,
      sku: normalizeSku(entry.sku || entry.product_sku || entry.productSku || '')
    });
  }

  function addSkuEntry(entries, sku) {
    var cleanSku = normalizeSku(sku);
    if (!cleanSku) return;

    addEntry(entries, {
      sku: cleanSku,
      handle: cleanSku,
      url: '/products/' + cleanSku,
      title: cleanSku
    });
  }

  function parseRaw(raw, entries) {
    var text = String(raw || '').replace(/\\\//g, '/');
    if (!text) return;

    try {
      var parsed = JSON.parse(text);
      traverse(parsed, entries);
    } catch (e) {}

    var anchorPattern = /<a\b[^>]*href=["']([^"']+)["'][^>]*>(.*?)<\/a>/ig;
    var anchorMatch;
    while ((anchorMatch = anchorPattern.exec(text))) {
      addEntry(entries, { url: anchorMatch[1], title: anchorMatch[2].replace(/<[^>]+>/g, ' ') });
    }

    var urlPattern = /(https?:\/\/[^"'<>\s]+\/products\/[^"'<>\s,;]+|\/products\/[^"'<>\s,;]+)/ig;
    var urlMatch;
    while ((urlMatch = urlPattern.exec(text))) addEntry(entries, { url: urlMatch[1] });

    // Some AllConjugations values store SKU/handle tokens rather than full product links.
    // Convert those to product URLs so the dropdown still points to product pages.
    var suffixPattern = '(?:percp-cy5\\.5|percp-cy5-5|apc-cy5\\.5|apc-cy5-5|apc-cy7|pe-cy5\\.5|pe-cy5-5|pe-cy7|pe-cy5|bf350|bf405|bf488|bf555|bf594|bf647|bf680|bf750|biotin|fitc|tritc|rbitc|percp|hrp|apc|cy3|cy5\\.5|cy5-5|cy5|cy7|pe|ap)';
    var skuPattern = new RegExp('\\b(bs[mfp]?-[0-9]{2,8}[a-z]?(?:-' + suffixPattern + '))\\b', 'ig');
    var skuMatch;
    while ((skuMatch = skuPattern.exec(text))) addSkuEntry(entries, skuMatch[1]);
  }

  function traverse(value, entries) {
    if (!value) return;
    if (Array.isArray(value)) {
      value.forEach(function (item) { traverse(item, entries); });
      return;
    }
    if (typeof value === 'object') {
      addEntry(entries, value);
      Object.keys(value).forEach(function (key) {
        if (typeof value[key] === 'object') traverse(value[key], entries);
      });
      return;
    }
    if (typeof value === 'string') parseRaw(value, entries);
  }

  function entriesFromPayload(payload) {
    var entries = [];
    if (!payload) return entries;

    if (Array.isArray(payload.entries)) {
      payload.entries.forEach(function (entry) { addEntry(entries, entry); });
    }

    parseRaw(payload.all_conjugations_raw, entries);
    parseRaw(payload.all_conjugations_value_raw, entries);

    var seen = {};
    return entries.filter(function (entry) {
      var key = (entry.url || '').toLowerCase();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function buildGroups(payload) {
    var sourceSku = normalizeSku(payload.source_sku || payload.base_sku || payload.sku || payload.source_handle || '');
    var baseSku = normalizeSku(payload.base_sku || stripKnownSuffix(sourceSku || payload.source_handle || ''));
    var entries = entriesFromPayload(payload);

    var grouped = {
      unconjugated: [],
      abby: [],
      standard: [],
      other: []
    };

    var sourceUrl = normalizeUrl(payload.source_url || '');

    // For conjugated cards, never use the current card URL as the Unconjugated destination.
    // Prefer source_url from the resolved base product. If that is missing or incorrect,
    // find the base product in the AllConjugations entries or fall back to /products/{baseSku}.
    if (baseSku) {
      var sourceHandle = normalizeSku(payload.source_handle || handleFromUrl(sourceUrl));
      var currentHandle = normalizeSku(payload.handle || handleFromUrl(payload.url || ''));

      if (!sourceUrl || sourceHandle !== baseSku || sourceHandle === currentHandle && normalizeSku(payload.sku || '') !== baseSku) {
        sourceUrl = '';
        entries.some(function (entry) {
          var candidate = normalizeSku(entry.sku || entry.handle || handleFromUrl(entry.url));
          if (candidate === baseSku) {
            sourceUrl = entry.url;
            return true;
          }
          return false;
        });
      }

      if (!sourceUrl) sourceUrl = '/products/' + baseSku;
    }

    if (sourceUrl) {
      grouped.unconjugated.push({ label: 'Unconjugated', url: sourceUrl, group: 'unconjugated' });
    }

    var seen = {};
    if (sourceUrl) seen['unconjugated:unconjugated'] = true;

    entries.forEach(function (entry) {
      var label = labelFromText([entry.title, entry.sku, entry.handle, entry.url].join(' '), baseSku);
      if (!label) return;

      var group = groupForLabel(label);

      // Only one Unconjugated option should appear, and it should already point to the base product.
      if (group === 'unconjugated') {
        if (!grouped.unconjugated.length && entry.url) {
          grouped.unconjugated.push({ label: 'Unconjugated', url: entry.url, group: 'unconjugated' });
        }
        return;
      }

      // One visible option per conjugation label. If the metafield contains duplicates
      // for the same conjugation, keep the first usable product URL.
      var key = group + ':' + label.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;

      grouped[group].push({ label: label, url: entry.url, group: group });
    });

    return grouped;
  }

  function hasOptions(grouped) {
    return grouped && (grouped.abby.length || grouped.standard.length || grouped.other.length);
  }

  function findInsertTarget(card) {
    if (!card || !card.querySelector) return null;
    var title = card.querySelector(TITLE_SELECTOR);
    if (!title) return null;
    return title.closest ? (title.closest('h1, h2, h3, header, div') || title) : title;
  }

  function makeOption(option) {
    var a = document.createElement('a');
    a.className = 'bioss-conj-option';
    a.href = option.url;
    a.setAttribute('aria-label', 'View ' + option.label + ' product');

    var dot = document.createElement('span');
    dot.className = 'bioss-conj-dot ' + swatchClass(option.label, option.group);
    dot.setAttribute('aria-hidden', 'true');

    var label = document.createElement('span');
    label.className = 'bioss-conj-label';
    label.textContent = option.label;

    a.appendChild(dot);
    a.appendChild(label);
    return a;
  }

  function makeDropdown(grouped) {
    var wrap = document.createElement('div');
    wrap.className = 'bioss-conj-options';
    wrap.setAttribute('data-bioss-conj-options', 'true');

    var details = document.createElement('details');
    details.className = 'bioss-conj-details';

    var summary = document.createElement('summary');
    summary.className = 'bioss-conj-summary';
    summary.textContent = 'Conjugation Options';

    var panel = document.createElement('div');
    panel.className = 'bioss-conj-panel';

    GROUPS.forEach(function (group) {
      var groupEl = document.createElement('div');
      groupEl.className = 'bioss-conj-group bioss-conj-group--' + group.key;

      var heading = document.createElement('div');
      heading.className = 'bioss-conj-heading';
      heading.textContent = group.title;

      var list = document.createElement('div');
      list.className = 'bioss-conj-list';

      var options = grouped[group.key] || [];
      if (options.length) {
        options.forEach(function (option) { list.appendChild(makeOption(option)); });
      } else {
        var empty = document.createElement('span');
        empty.className = 'bioss-conj-empty';
        empty.textContent = '—';
        list.appendChild(empty);
      }

      groupEl.appendChild(heading);
      groupEl.appendChild(list);
      panel.appendChild(groupEl);
    });

    details.appendChild(summary);
    details.appendChild(panel);
    wrap.appendChild(details);
    return wrap;
  }

  function insertDropdown(card, grouped) {
    if (!card || card.querySelector('[data-bioss-conj-options]')) return false;
    var target = findInsertTarget(card);
    if (!target || !target.parentNode) return false;

    var dropdown = makeDropdown(grouped);
    if (target.nextSibling) target.parentNode.insertBefore(dropdown, target.nextSibling);
    else target.parentNode.appendChild(dropdown);
    return true;
  }

  function shouldShow(payload) {
    return payload && (payload.has_all_conjugations === true || payload.is_conjugated === true);
  }

  function processCard(card) {
    if (!card) return;

    var state = card.getAttribute('data-bioss-conj-options-state');
    if (state === 'true' || state === 'loading' || state === 'none') return;

    var productUrl = productUrlFromCard(card);
    var endpoint = endpointFromProductUrl(productUrl);
    if (!endpoint) return;

    card.setAttribute('data-bioss-conj-options-state', 'loading');

    fetchPayload(endpoint).then(function (payload) {
      if (!shouldShow(payload)) {
        card.setAttribute('data-bioss-conj-options-state', 'none');
        return;
      }

      var grouped = buildGroups(payload);
      if (hasOptions(grouped) && insertDropdown(card, grouped)) {
        card.setAttribute('data-bioss-conj-options-state', 'true');
      } else {
        // Do not leave an incomplete first-card render on the page. If AllConjugations
        // exists but no conjugated entries parsed yet, retry briefly instead of showing
        // only Unconjugated with empty groups.
        card.removeAttribute('data-bioss-conj-options-state');
        window.setTimeout(schedule, 700);
      }
    });
  }

  function scan() {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i += 1) processCard(cards[i]);
  }

  function schedule() {
    if (scanTimer) window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      scanTimer = null;
      scan();
    }, 180);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', function () {
    schedule();
    window.setTimeout(schedule, 300);
    window.setTimeout(schedule, 600);
    window.setTimeout(schedule, 1600);
    window.setTimeout(schedule, 3200);
    window.setTimeout(schedule, 5200);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () { schedule(); });
    observer.observe(document.querySelector('.products') || document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 90000);
  }

  var interval = window.setInterval(function () {
    if (Date.now() - startedAt > 90000) {
      window.clearInterval(interval);
      return;
    }
    schedule();
  }, 2200);
})();
